<div class="question-response-container">
  <mat-radio-group
    [formControl]="questionControl"
    class="radio-group">
    <mat-radio-button class="radio-button"
      [disabled]="readOnly"
      [value]="'yes'">
      {{ 'common.yes' | translate }}
    </mat-radio-button>
    <mat-radio-button class="radio-button"
      [disabled]="readOnly"
      [value]="'no'">
      {{ 'common.no' | translate }}
    </mat-radio-button>
  </mat-radio-group>
</div>
